/**
 * PATH: apps/inventory/src/pages/AlertsPage.tsx
 * PURPOSE: Inventory alerts
 */
import { EmptyRegister } from './emptyRegister'

export default function AlertsPage() {
  return (
    <EmptyRegister
      title="Alerts"
      detail="No stock alerts are connected."
    />
  )
}
